fetchJson = require './fetch-json'

module.exports = {
  getAll: (options={}) ->
    fetchJson("/db/cla.submissions", options)
}



// WEBPACK FOOTER //
// ./app/core/api/clas.coffee